(function () {
  var header = document.querySelector('.nmd-header');
  if (!header) return;

  var trigger = header.querySelector('[data-nmd-trigger]');
  var menu = header.querySelector('[data-nmd-menu]');
  var scrim = document.querySelector('[data-nmd-scrim]');
  var searchOpenBtn = header.querySelector('[data-nmd-search-open]');
  var searchPanel = header.querySelector('[data-nmd-search-panel]');
  var searchCloseBtn = header.querySelector('[data-nmd-search-close]');
  var searchForm = header.querySelector('[data-nmd-search-form]');
  var searchInput = header.querySelector('[data-nmd-search-input]');
  var searchResults = header.querySelector('[data-nmd-search-results]');
  var searchSuggestions = header.querySelector('[data-nmd-search-suggestions]');
  var closeTimer = null;
  var debounceTimer = null;

  function openMenu() {
    clearTimeout(closeTimer);
    closeSearch();
    menu.classList.add('is-open');
    header.classList.add('is-menu-open');
    document.body.classList.add('nmd-menu-open');
    if (trigger) {
      trigger.classList.add('is-open');
      var a = trigger.querySelector('a');
      if (a) a.setAttribute('aria-expanded', 'true');
    }
  }

  function closeMenu() {
    menu.classList.remove('is-open');
    header.classList.remove('is-menu-open');
    document.body.classList.remove('nmd-menu-open');
    if (trigger) {
      trigger.classList.remove('is-open');
      var a = trigger.querySelector('a');
      if (a) a.setAttribute('aria-expanded', 'false');
    }
  }

  // 120ms close delay so diagonal travel into the panel doesn't dismiss it
  function delayedClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeMenu, 120);
  }

  if (trigger && menu) {
    trigger.addEventListener('mouseenter', openMenu);
    trigger.addEventListener('mouseleave', delayedClose);
    menu.addEventListener('mouseenter', openMenu);
    menu.addEventListener('mouseleave', delayedClose);
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (menu.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  }

  function openSearch() {
    closeMenu();
    searchPanel.classList.add('is-open');
    header.classList.add('is-search-open');
    document.body.classList.add('nmd-search-open');
    setTimeout(function () { searchInput.focus(); }, 100);
  }

  function closeSearch() {
    if (!searchPanel) return;
    searchPanel.classList.remove('is-open');
    header.classList.remove('is-search-open');
    document.body.classList.remove('nmd-search-open');
    if (searchInput) searchInput.value = '';
    if (searchResults) searchResults.innerHTML = '';
    if (searchSuggestions) searchSuggestions.style.display = '';
  }

  if (searchOpenBtn && searchPanel) {
    searchOpenBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (searchPanel.classList.contains('is-open')) {
        closeSearch();
      } else {
        openSearch();
      }
    });
    searchCloseBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeSearch();
    });
  }

  if (scrim) {
    scrim.addEventListener('click', function () {
      closeMenu();
      closeSearch();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMenu();
      closeSearch();
    }
  });


  // Collections come back inside the generic Suggestions <ul> (queries and
  // collections share it). Lift them into their own labelled group so they
  // read as destinations, not search-term guesses.
  function splitCollections(results, prefix) {
    var ul = results.querySelector('.search__results__suggestions ul');
    if (!ul) return;
    var cols = Array.prototype.filter.call(ul.querySelectorAll('li'), function (li) {
      var a = li.querySelector('a');
      return a && a.getAttribute('href') && a.getAttribute('href').indexOf('/collections/') > -1;
    });
    if (!cols.length) return;
    var group = document.createElement('div');
    group.className = prefix + '-col-group';
    var label = document.createElement('p');
    label.className = prefix + '-col-group__label';
    label.textContent = 'Collections';
    var row = document.createElement('div');
    row.className = prefix + '-col-group__row';
    cols.slice(0, 1).forEach(function (li) {
      var a = li.querySelector('a');
      var chip = document.createElement('a');
      chip.className = prefix + '-col-chip';
      chip.href = a.getAttribute('href');
      chip.textContent = a.textContent.trim();
      row.appendChild(chip);
      li.remove();
    });
    cols.slice(1).forEach(function (li) { li.remove(); });
    group.appendChild(label); group.appendChild(row);
    var sug = results.querySelector('.search__results__suggestions');
    // no query suggestions left? drop the empty Suggestions block
    if (sug && !sug.querySelectorAll('li').length) sug.remove();
    results.insertBefore(group, results.firstChild);
  }

  // Predictive search — same endpoint + markup recipe as the mobile overlay
  function fetchResults(term) {
    if (!term) return;
    if (searchSuggestions) searchSuggestions.style.display = 'none';
    var url = window.PXUTheme.routes.predictive_search_url
      + '?q=' + encodeURIComponent(term)
      + '&resources[limit]=10&resources[limit_scope]=each'
      + '&resources[type]=product,collection'
      + '&resources[options][fields]=title,product_type,tag,body,vendor'
      + '&section_id=predictive-search';
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var results = doc.querySelector('.search__results');
        searchResults.innerHTML = '';
        if (results) {
          // Same de-clutter as mobile: max 3 suggestions, no Pages group,
          // no 'Search for' CTA (Enter / submit reach the results page).
          splitCollections(results, 'nmd');
          var sugg = results.querySelectorAll('.search__results__suggestions li');
          Array.prototype.slice.call(sugg, 3).forEach(function (li) { li.remove(); });
          var pages = results.querySelector('.search__results__pages-posts');
          if (pages) pages.remove();
          searchResults.appendChild(results);
          addScrollArrow(results);
        } else {
          var noResults = doc.querySelector('.no-results');
          searchResults.innerHTML = noResults ? noResults.outerHTML : '';
        }
      });
  }

  // Right-edge arrow on the products row when it overflows; advances one
  // viewport per click, hides at the end of the row.
  function addScrollArrow(results) {
    var prodWrap = results.querySelector('.search__results__products');
    var prodUl = prodWrap && prodWrap.querySelector('ul');
    if (!prodUl || prodUl.scrollWidth <= prodUl.clientWidth + 4) return;
    var arrow = document.createElement('button');
    arrow.type = 'button';
    arrow.className = 'nmd-results-arrow';
    arrow.setAttribute('aria-label', 'Scroll for more products');
    arrow.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
    var thumb = prodUl.querySelector('.search__results__thumbnail');
    if (thumb) {
      var t = thumb.getBoundingClientRect();
      var w = prodWrap.getBoundingClientRect();
      arrow.style.top = (t.top - w.top + t.height / 2) + 'px';
    }
    prodWrap.appendChild(arrow);
    arrow.addEventListener('click', function () {
      prodUl.scrollBy({ left: prodUl.clientWidth, behavior: 'smooth' });
    });
    prodUl.addEventListener('scroll', function () {
      var atEnd = prodUl.scrollLeft + prodUl.clientWidth >= prodUl.scrollWidth - 8;
      arrow.classList.toggle('is-hidden', atEnd);
    }, { passive: true });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var term = searchInput.value.trim();
      clearTimeout(debounceTimer);
      if (term.length === 0) {
        searchResults.innerHTML = '';
        if (searchSuggestions) searchSuggestions.style.display = '';
        return;
      }
      debounceTimer = setTimeout(function () { fetchResults(term); }, 200);
    });
  }

  header.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-nmd-trending-pill]');
    if (!pill) return;
    e.preventDefault();
    var keyword = pill.getAttribute('data-nmd-trending-pill');
    searchInput.value = keyword;
    searchInput.focus();
    fetchResults(keyword);
  });

  if (searchForm) {
    searchForm.addEventListener('submit', function (e) {
      if (searchInput.value.trim().length === 0) e.preventDefault();
    });
  }
})();
